module.exports = __webpack_public_path__ + "img/SecretDreamer.35508e93.jpg";